// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C2j4","type":"styles_type__2G8TY","choices":"styles_choices__3zWBd"};